"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Health = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Health"));
var _HealthActive = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/HealthActive"));
var _addToFavoritesModule = _interopRequireDefault(require("./add-to-favorites.module.css"));
var AddToFavorites = function AddToFavorites(_ref) {
  var isFavorited = _ref.isFavorited,
    favoriteCallback = _ref.favoriteCallback,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var favoriteText = isFavorited ? 'Favorited' : 'Favorite';
  var favoriteIcon = isFavorited ? /*#__PURE__*/_react.default.createElement(_HealthActive.default, null) : /*#__PURE__*/_react.default.createElement(_Health.default, null);
  return /*#__PURE__*/_react.default.createElement("button", {
    className: _addToFavoritesModule.default.favoritesWrapper,
    style: {
      gridArea: isMobile ? 'compareBtn' : 'addToCompare'
    },
    onClick: favoriteCallback
  }, favoriteIcon, " ", !isMobile && /*#__PURE__*/_react.default.createElement("span", null, favoriteText));
};
var _default = AddToFavorites;
exports.default = _default;